// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d0371cb0","796":"53e7501e"}[chunkId] + ".chunk.js";
};